import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

interface StoreInvitationProps {
  onAddProduct: () => void;
}

const StoreInvitation: React.FC<StoreInvitationProps> = ({ onAddProduct }) => {
  const [t] = useTranslation('store');

  return (
    <div className="card bg-base-100 shadow-xl">
      <div className="card-body items-center text-center">
        <h2 className="card-title text-primary mb-4 text-3xl">
          {t('store_invitation_title')}
        </h2>

        <p className="text-base-content mb-6 max-w-3xl text-lg">
          {t('store_invitation_description')}
        </p>

        <p className="text-base-content/70 mb-8 max-w-2xl text-base">
          {t(
            'store_invitation_benefits',
            'Gestiona tu catálogo, controla tu inventario, y permite a tus clientes descubrir tus productos a través de una experiencia de compra conversacional impulsada por IA.',
          )}
        </p>

        <div className="card-actions">
          <button onClick={onAddProduct} className="btn btn-primary btn-lg">
            {t('start_adding_products')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StoreInvitation;
